// import moment from 'moment'
import moment from 'moment-timezone'

let baseUrl = '/api/'
// if (process.env.NODE_ENV === 'development') {
//   baseUrl = 'http://oauth.aks.hscloud.top/api/'
//   // baseUrl = 'https://intern-voice.dkl.douwa.tech/api/'
//   // baseUrl = 'http://192.168.0.225:5000/api/'
// }

// const variable
let c = {
  // 语言值
  LanguageItem: [
    {
      label: 'English',
      value: 'en',
      name: 'en',
      label_cn: '英语'
    },
    {
      label: '简体中文',
      value: 'zh_cn',
      name: 'zh_cn',
      label_cn: '简体中文'
    }
  ]
}

// api url
let api = {
  provider: baseUrl + 'provider/',
  auth: baseUrl + 'auth/',
  login: baseUrl + 'auth/login/',
  apps: baseUrl + 'apps/',
  app: baseUrl + 'app/',
  roles: baseUrl + 'app/roles/',
  role: baseUrl + 'app/role/',
  perms: baseUrl + 'app/perms/',
  perm: baseUrl + 'app/perm/',
  groups: baseUrl + 'app/groups/',
  group_childs: baseUrl + 'app/group/childs/',
  group: baseUrl + 'app/group/',
  appusers: baseUrl + 'app/users/',
  appuser: baseUrl + 'app/user/',
  users: baseUrl + 'users/',
  user: baseUrl + 'user/',
  logout: baseUrl + 'auth/logout/',
  applay: baseUrl + 'app',
  appgroups: baseUrl + 'current/app_user/',
  current_users_perms: baseUrl + 'current/app/perms/',
  current_users_groups: baseUrl + 'current/app/groups/',
  curren_access_tokens: baseUrl + 'current/access_tokens/',
  current_access_token: baseUrl + 'current/access_token/',
  current_password_change: baseUrl + 'current/password/change/',
  current_password_setting: baseUrl + 'current/password/setting/',
  currentUsers: baseUrl + 'current/user/',
  forgetPsssword: baseUrl + 'password/forget',
  resetPsssword: baseUrl + 'password/reset',
  resetPssswordEmail: baseUrl + 'password/reset_by_email',
  banUser: baseUrl + 'app/user/status/',
  sendEmailNumber: baseUrl + 'email/send_valid_number/',
  bindEmail: baseUrl + 'email/bind_email/',
  getApprovalData: baseUrl + 'register/approval_users/',
  modifyApprovalStatus: baseUrl + 'register/status/',
  getSingleApprovalData: baseUrl + 'register/approval_user/',
  createApprovalData: baseUrl + 'register/create/',
  checkApprovalData: baseUrl + 'register/check/?name=',
  createUser: baseUrl + 'create_user/',
  validUserName: baseUrl + 'get_user_by_username/',
  deleteWechat: baseUrl + 'provider/delete_wechat',
  createWechat: baseUrl + 'provider/create_wechat/',
  corsToken: '/test/cors_token/',
  cppCountry: '/cpp/oauth/country/',
  cppDpp: '/cpp/oauth/dpp/'
}

let storage = {
  set_token (token) {
    localStorage.setItem('token', token)
  },
  get_token () {
    let token = localStorage.getItem('token', undefined)
    return token
  },
  remove_token () {
    localStorage.removeItem('token')
  }
}

function formatToDate (createdTime) {
  // return moment(createdTime).format('YYYY-MM-DD')
  return moment.utc(createdTime).tz('Asia/Shanghai').format('YYYY-MM-DD')
}

function formatToTime (createdTime) {
  return moment.utc(createdTime).tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss')
  // return moment.utc(createdTime).utcOffset(8).format('YYYY-MM-DD HH:mm:ss')
}

function formatTime (createdTime, formatStr) {
  return moment.utc(createdTime).tz('Asia/Shanghai').format(formatStr)
}

function convertUTCTimeToLocalTime (UTCDateString) {
  if(!UTCDateString){
    return '-';
  }
  function formatFunc(str) {    //格式化显示
    return str > 9 ? str : '0' + str
  }
  var date2 = new Date(UTCDateString);     //这步是关键
  var year = date2.getFullYear();
  var mon = formatFunc(date2.getMonth() + 1);
  var day = formatFunc(date2.getDate());
  var hour = date2.getHours();
  var noon = hour >= 12 ? 'PM' : 'AM';
  hour = hour>=12?hour-12:hour;
  hour = formatFunc(hour);
  var min = formatFunc(date2.getMinutes());
  var dateStr = year+'-'+mon+'-'+day+' '+noon +' '+hour+':'+min;
  return dateStr;
}


export default {
  // const variable
  c,
  // api url
  api,
  storage,
  formatToDate,
  formatToTime,
  formatTime,
  convertUTCTimeToLocalTime
}



// WEBPACK FOOTER //
// ./src/utils/index.js